import React from "react";
import VerificationComponent from "../components/VerificationComponent";

export default function Verification() {
  return <VerificationComponent />;
}
